import React, { useCallback, useEffect, useState } from 'react';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { MdArrowForward, MdPlayArrow } from 'react-icons/md';
import { RiCheckboxCircleLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';

import Logo from '~/assets/logo-blue.svg';
import ContainedButton from '~/components/layout/form/containedButton';
import Loading from '~/components/layout/loading';
import Stepper from '~/components/layout/Stepper';

import api from '~/services/api';

import {
  Body,
  ButtonContainer,
  Container,
  Content,
  HeaderContainer,
  Img,
  Section,
  SideBanner,
  SuccessContainer,
} from './styles';

const ConfirmacaoEmail = () => {
  const [emailLoading] = useState({
    title: 'Validação de E-mail',
    subTitle: '',
    text: 'Carregando...',
  });

  const [emailSuccess] = useState({
    title: 'Tudo certo!!',
    subTitle:
      'Agora você pode acessar o portal para gerenciar o gás do seu negócio, na hora que quiser e aonde estiver.',
    text: 'Seu cadastro foi realizado com sucesso!',
  });

  const [emailExpiration] = useState({
    title: 'E-mail expirado!',
    subTitle: 'O seu e-mail de ativação expirou.',
    text:
      'Não foi possível concluir seu cadastro, seu e-mail de ativação está expirado, por favor tente novamente',
  });

  const [tokenInvalid] = useState({
    title: 'Token Inválido!',
    subTitle: 'O seu e-mail de ativação é inválido',
    text:
      'Não foi possível concluir seu cadastro, seu e-mail de ativação é inválido, favor tente novamente',
  });

  const [loading, setLoading] = useState(false);

  const [emailState, setEmailState] = useState(emailLoading);

  const [errorState, setErrorState] = useState(null);

  const [steppers] = useState([
    'Sua identificação',
    'Selecione seu e-mail',
    'Selecione seu telefone',
    'Ativação da conta',
    'Concluído',
  ]);

  const requestValidationEmail = useCallback(
    async (token, userId) => {
      setLoading(true);
      const body = {
        token,
      };

      try {
        await api.post(
          `/industrial/customer/v1/users/${userId}/validations`,
          body,
        );
        setEmailState(emailSuccess);
      } catch (error) {
        setEmailState(emailExpiration);
        setErrorState(5);
      }
      setLoading(false);
    },
    [setLoading, api, setEmailState, setErrorState],
  );

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const userId = params.get('user-id');
    requestValidationEmail(token, userId);
  }, []);

  return (
    <Container>
      <SideBanner>
        <Link to="/">
          <Img src={Logo} alt="Logo da Ultragaz" />
        </Link>
        <Stepper
          activated={6}
          errorState={errorState}
          steppers={steppers}
          scrollToEnd={false}
        />
      </SideBanner>
      <Content>
        <Body>
          <Section>
            <HeaderContainer>
              <span>
                <MdPlayArrow />
                &nbsp;&nbsp;Primeiro Acesso
              </span>
              <h1>{emailState.title}</h1>
              <h2>{emailState.subTitle}</h2>
            </HeaderContainer>

            <SuccessContainer errorState={errorState}>
              {!loading &&
                (!errorState ? (
                  <RiCheckboxCircleLine size={60} />
                ) : (
                  <IoMdCloseCircleOutline size={60} />
                ))}
              <p>{emailState.text}</p>
            </SuccessContainer>

            <ButtonContainer>
              <Link to="/">
                <ContainedButton
                  color="#4EC937"
                  TrailingIcon={() => <MdArrowForward size={20} />}
                >
                  Acesse o portal
                </ContainedButton>
              </Link>
            </ButtonContainer>
          </Section>
        </Body>
      </Content>
      {loading && <Loading />}
    </Container>
  );
};

export default ConfirmacaoEmail;
